'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'far';
var iconName = 'chart-area';
var width = 512;
var height = 512;
var aliases = ["area-chart"];
var unicode = 'f1fe';
var svgPathData = 'M48 56c0-13.3-10.7-24-24-24S0 42.7 0 56L0 400c0 44.2 35.8 80 80 80l408 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L80 432c-17.7 0-32-14.3-32-32L48 56zm209.7 47.8c-4.5-5-11-7.8-17.7-7.8s-13.1 2.8-17.7 7.8l-104 113.5c-4.1 4.4-6.3 10.2-6.3 16.2L112 344c0 13.3 10.7 24 24 24l320 0c13.3 0 24-10.7 24-24l0-128c0-6.4-2.5-12.5-7-17l-64-64c-9.4-9.4-24.6-9.4-33.9 0l-46.3 46.3-71.1-77.5zM160 320l0-77.2 80-87.3 70.3 76.7c4.4 4.8 10.6 7.6 17.2 7.8s12.9-2.4 17.5-7l47-47 40 40 0 94.1-272 0z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faChartArea = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;